export const cardArtMapping = {
  'the-platinum-card': 'platinum-card-art',
  'the-platinum-card-cmbc': 'platinum-card-art',
  'the-platinum-card-asal': 'platinum-card-art',
  'the-platinum-card-aeme': 'platinum-card-art',
  'the-platinum-card-idc-en': 'platinum-card-art-idc',
  'the-platinum-card-idc-es': 'platinum-card-art-idc',
  'delta-reserve': 'delta-sky-miles-card-art',
  'spg-luxury-card': 'marriot-bonvoy-card-art',
  'the-centurion-card': 'centurion-card-art',
  'the-centurion-card-cmbc': 'centurion-card-art',
  'the-centurion-card-asal': 'centurion-card-art',
  'the-centurion-card-sa': 'centurion-card-art',
  'the-centurion-card-argentina': 'centurion-card-art',
};

export const mycaCardTypes = {
  // We use the MYCA API to get info about the logged in cardmember's accounts.
  // They have their own way of specifying the types of cards. Some cards have more than one type.
  // We can note the MYCA types in this object and map them to one of our product URLs below.
  platinum: 'Platinum',
  centurion: 'Centurion',
  deltaReserve: 'DeltaReserve',
};

export const productUrlToProductTypeMap = {
  'the-platinum-card': mycaCardTypes.platinum,
  'the-platinum-card-cmbc': mycaCardTypes.platinum,
  'the-platinum-card-asal': mycaCardTypes.platinum,
  'the-platinum-card-aeme': mycaCardTypes.platinum,
  'the-platinum-card-idc-en': mycaCardTypes.platinum,
  'the-platinum-card-idc-es': mycaCardTypes.platinum,
  'delta-reserve': mycaCardTypes.deltaReserve,
  'the-centurion-card': mycaCardTypes.centurion,
  'the-centurion-card-cmbc': mycaCardTypes.centurion,
  'the-centurion-card-asal': mycaCardTypes.centurion,
  'the-centurion-card-sa': mycaCardTypes.centurion,
  'the-centurion-card-argentina': mycaCardTypes.centurion,
};
